define('modules/editor/models/elements/section',['require','exports','module','backbone','../property_group_factory','../../collections/bricks','lib/util','./area','../../behaviours/has_property_groups','../../behaviours/has_elements'],function (require, exports, module) {
  "use strict";

  var Backbone = require("backbone"),
      PropertyGroupFactory = require("../property_group_factory"),
      BricksCollection = require("../../collections/bricks"),
      util = require("lib/util"),
      Area = require("./area");


  /**
   * Section Model
   * A Section is a basic element container within a Page
   * Elements are stored in an ElementCollection
   */

  /**
   * Section Model property group configuration
   * @type {Array}
   */
  var SectionPropertyGroups = [
    {
      name: "sectionGeometry",
      defaults: {
        width: 805,
        height: 300,
        marginBottom: 0,
        wide: false
      }
    },
    {
      name: "idclass",
      defaults: {
        id: "",
        className: ""
      }
    },
    {
      name: "background",
      defaults: {
        color: "#ffffff"
      }
    },
    {
      name: "border",
      defaults: {
        type: "none",
        width: 1,
        color: "#000000",
        position: "in",
        top: true,
        bottom: true,
        left: true,
        right: true,
        radius: 0
      }
    }
  ];

  /**
   * Serialization methods
   * @type {Object}
   */
  var Serialization = {
    fromJSON: function (json) {
      var section = new module.exports(_.omit(json, "elements"), {silenceNotify: true}),
          elementModels = BricksCollection.fromJSON(json.elements);

      section.elements.reset(elementModels.toArray());
      return section;
    },
    toJSON: function () {
      return _.extend(
          module.exports.__super__.toJSON.call(this),
          {elements: this.elements.toJSON()},
          {properties: _.invoke(this.propertyGroups, "toJSON")}
      );
    }
  };

  /**
   * Section Model definition
   */
  module.exports = Backbone.Model.extend({
    name: "section",
    defaultNameKey: "section",
    geometryProperty: "sectionGeometry",
    propertyGroups: SectionPropertyGroups,

    constructor: function (attributes, options) {
      module.exports.__super__.constructor.apply(this, arguments);
      // NOTE: sometimes when fetching from server, this is called before parse
      // that's why we need to configure property groups here
      this.setPropertyGroups(_.result(attributes, 'properties'), _.pick(options, ["silenceNotify"]));
    },

    initialize: function () {
      module.exports.__super__.initialize.apply(this, arguments);
      this.elements = this.elements || new BricksCollection();
    },

    _trig: function () {
      this._triggerAddElement();
    },

    /**
     * Adjusts the section width
     */
    adjustWidth: function (inc) {
      var geo = this.getPropertyGroup("sectionGeometry"),
          currentWidth = parseInt(geo.get("width")),
          newWidth = currentWidth + inc;
      geo.set("width", newWidth);
    },

    /**
     * Hook - triggered from Page model when this section is
     * going to be deleted
     */
    onBeforeRemove: function () {
      this.elements.each(_.bind(function (element) {
        if (element) {
          //guard against free form button deleted by parent form
          element.triggerMethod("remove");
          this.collection.trigger("remove:element", element, this);
        }
      }, this));
    },

    /**
     * Returns the section size properties
     * @return {object}
     */
    getSize: function () {
      var geometry = this.getPropertyGroup("sectionGeometry");
      return {
        height: parseInt(geometry.get("height")),
        width: parseInt(geometry.get("width"))
      };
    },

    /**
     * Just for uniform interface with base element model
     * A section has no position at all
     * @return {Object} empty x,y properties
     */
    getPosition: function () {
      return {x: 0, y: 0};
    },

    setPosition: function (pos) {
      //do nothing
    },

    /**
     * Sets this Section's size
     * @param {object} s       Hash with size props
     * @param {object} options Default Backbone.Model.set options
     */
    setSize: function (s, options) {
      var geometry = this.getPropertyGroup("sectionGeometry"),
          w = geometry.get("width"),
          h = geometry.get("height");
      if (w !== s.width || h !== s.height) {
        geometry.set({
          width: s.width || geometry.get("width"),
          height: s.height || geometry.get("height")
        }, options);
      }
    },

    getIdProp: function () {
      var idclass = this.getPropertyGroup("idclass");
      return idclass.get("id");
    },

    addArea: function (attributes) {
      return new Area(attributes);
    },

    toJSON: Serialization.toJSON
  },
  {
    fromJSON: Serialization.fromJSON
  });

  util.mixin(module.exports, require("../../behaviours/has_property_groups"));
  util.mixin(module.exports, require("../../behaviours/has_elements"));

});

